module.exports = __webpack_public_path__ + "media/images/facebook2x-5e65a107a4c3f673788ea09d605ca6aa.png";